import { useQuery } from "@tanstack/react-query";
import { getProgramInvoice } from "../../api/apiInvoices";

export const useGetProgramInvoice = (programId) => {
    return useQuery({
        queryKey: ["programInvoice", programId],
        queryFn: () => getProgramInvoice(programId),
        enabled: !!programId,
    });
};

export default useGetProgramInvoice;
